<template>
  <div class="col-md-9 col-lg-10 ml-md-auto py-4">
    <div class="header d-flex justify-content-between w-100 align-items-center py-3 mb-4 border-bottom border-dark">
      <h2 class="m-0">ダッシュボード</h2>
      <router-link class="text-white" to="/administrator/memberList"><b-button class="px-4 py-2" variant="primary">会員一覧へ</b-button></router-link>
    </div>
    <h3 class="mb-4">直近1ヶ月の会員登録状況</h3>
    <div v-if="!latestMember.data.length">登録はありません</div>
    <template v-else>
      <div class="responsive-table pb-5 mb-5">
        <b-table id="my-table"  head-variant="p-3 mb-2 bg-light text-dark"
          bordered
          responsive
          :items="latestMember.data"
          :per-page="perPage"
          :current-page="currentPage"
          :fields="fields"
          select-mode="single"
          selectable
          @row-selected="onRowSelected"
          hover
        >
          <template #cell(memberinfo.fullname)="row">
              <router-link class="text-dark" :to="'/administrator/edit-member/' + row.item.id"> {{ row.value }}</router-link>
          </template>
          <template #head(memberinfo.countryAndPrefecture)="">
            国名<br>都道府県
          </template>
          <template #cell(memberinfo.countryAndPrefecture)="row">
              {{ row.item.memberinfo.country }}<br>
              {{ row.item.memberinfo.prefectures }}
          </template>
          <template #head(memberinfo.properties)="">
            物件用途<br>検討物件
          </template>
          <template #cell(memberinfo.properties)="row">
              {{ $i18n.t(row.item.memberinfo.use_of_the_property) }}<br>
              {{ row.item.memberinfo.types_of_properties }}
          </template>
          <template #cell(memberinfo.business_type)="row">
              <span v-if="row.item.memberinfo.business_type_developer">{{ $i18n.t('business_type_developer') }}<br></span>
              <span v-if="row.item.memberinfo.business_type_mediator">{{ $i18n.t('business_type_mediator') }}<br></span>
              <span v-if="row.item.memberinfo.business_type_indivisual">{{ $i18n.t('business_type_indivisual') }}</span>
          </template>
          <template #cell(memberinfo.plan)="row">
              {{ row.item.contracts[0] ? row.item.contracts[0].price.product.name : '' }}
          </template>
        </b-table>
      </div>
      <div>
        <b-pagination align="center" size="lg"
          v-model="currentPage"
          :total-rows="latestMember.data.length"
          :per-page="perPage"
          :limit="4"
          :show-step-links="true"
          aria-controls
          first-number
          last-number
          v-show="pages"
        >
        <template #prev-text><span><b-icon icon="chevron-left" scale="1.5"></b-icon></span></template>
        <template #next-text><span><b-icon icon="chevron-right" scale="1.5"></b-icon></span></template>
        </b-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      fields: [
        { key: 'memberinfo.fullname', label: '氏名' },
        { key: 'memberinfo.countryAndPrefecture', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.age', label: '年齢' },
        {
          key: 'memberinfo.gender',
          label: '性別',
          formatter: value => {
            return this.$i18n.t(value.toLowerCase())
          }
        },
        { key: 'memberinfo.properties' },
        {
          key: 'memberinfo.desired_price_range',
          label: '価格帯',
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.business_type',
          label: '業種',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.area',
          label: 'エリア',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.plan',
          label: 'プラン',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.language',
          label: '言語',
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.email_magazine_delivery',
          label: 'メッセージ',
          formatter: value => {
            if (value) {
              return value.toUpperCase()
            }
          }
        },
        {
          key: 'created_at',
          label: '会員登録日',
          formatter: value => {
            return value.substring(0, 10).replace(/-/g, '/')
          }
        }
      ],
      rows: 8,
      perPage: 30,
      currentPage: 1,
      mylist: []
    }
  },
  computed: {
    ...mapState('latestMember', ['latestMember']),
    pages: function () {
      if (this.latestMember.data.length <= 30) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions('latestMember', ['getLatestMember']),
    onRowSelected (items) {
      this.$router.push({ name: 'Edit Member', params: { id: items[0].id } })
    }
  }
}
</script>
